var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('div',{staticClass:"container"},[_c('router-view',{key:_vm.$route.path})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }